import { MDBIcon } from 'mdb-react-ui-kit';
import { useEffect, useMemo, useState } from 'react';
import { Data } from '../../../../../../../service/global';
import { StatusDTO } from '@scm/common-legacy';

export interface PrizeBoxIndividualDoorItemProps {
    filled: boolean;
    status: StatusDTO[];
    selected?: boolean;
    className?: string;
    onClick?: () => void;
}

export const PrizeBoxIndividualDoorItem = ({
    filled,
    status,
    selected,
    className,
    onClick,
}: PrizeBoxIndividualDoorItemProps) => {
    const bg = useMemo(
        () =>
            status.length > 0
                ? (Data.esList[status[0].id]?.web?.level ?? 'success')
                : 'success',
        [status, Data, Data.esList],
    );

    return (
        <>
            <div
                className={`position-relative square border border-${selected ? 4 : 2} rounded-${selected ? 1 : 4} border-${selected ? 'warning' : bg} bg-${bg} bg-opacity-25 d-flex justify-content-center align-items-center ${className}`}
                style={{ width: 30, height: 30, margin: 1 }}
                onClick={onClick}
            >
                <span
                    className="position-absolute d-flex justify-content-center align-items-center"
                    style={{
                        opacity: !filled ? 0 : 1,
                        height: 15,
                    }}
                >
                    <MDBIcon icon="gift" color="primary" fixed />
                </span>
            </div>
        </>
    );
};
